import React, { Component } from 'react';
import * as yup from 'yup';

import { trans } from '../../../../localization';
import NowInput from '../../../../components/Common/NowInput';
import NowSelect from '../../../../components/Common/NowSelect';
import InputWrapper from '../../../../components/Common/InputWrapper';
import Modal, {
  ModalBody,
  ModalHeader,
} from '../../../../components/Modal/Modal';

class NowPortalAddBankAccountModal extends Component {
  static defaultState = {
    step: 1,
    isSubmitStep1: false,
    provinceOptions: [],
    officeOptions: [],
    bank: {},
    province: {},
    office: {},
    officeName: '',
    otpCode: '',
  };
  state = { ...NowPortalAddBankAccountModal.defaultState };

  resetState = () => {
    this.setState({ ...NowPortalAddBankAccountModal.defaultState });
  };

  handleSelectBank = (bank) => {
    const { getListProvinceNowPortal } = this.props;
    getListProvinceNowPortal(bank.value).then((provinces) => {
      this.setState({
        provinceOptions: provinces.map(province => ({
          value: province.id,
          label: province.name,
        })),
        bank,
        province: null,
        office: null,
      });
    });
  };

  handleSelectProvince = (province) => {
    const { bank } = this.state;
    const { getListOfficeNowPortal } = this.props;
    getListOfficeNowPortal(bank.value, province.value).then((offices) => {
      this.setState({
        officeOptions: [
          ...offices.map(office => ({
            value: office.id,
            label: office.name,
          })),
          {
            value: -1,
            label: 'Other',
          },
        ],
        province,
        office: null,
      });
    });
  };

  handleSelectOffice = office => this.setState({ office });

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleInputChange = name => (e) => {
    this.setState({
      [name]: e.target.value,
    });
  };

  handleStepChange = step => () => {
    const { step: currentStep } = this.state;

    if (currentStep === 1) {
      this.setState({ isSubmitStep1: true }, () => {
        if (this.validateStep1()) {
          this.setState({ step });
        }
      });
    } else if (currentStep === 2 && step === 3) {
      this.handleRequestOTP().then((isSuccess) => {
        if (isSuccess) {
          this.setState({ step });
        }
      });
    } else {
      this.setState({ step });
    }
  };

  handleRequestOTP = () => {
    const { applyNewBankAccount } = this.props;
    const reqParams = this.genBody();
    return applyNewBankAccount(reqParams);
  };

  handleClose = () => {
    const { onRequestClose } = this.props;
    onRequestClose();
    this.resetState();
  };

  handleSubmit = () => {
    const { otpCode } = this.state;
    const { setGeneralError, applyNewBankAccount } = this.props;
    const requiredMessage = trans('merchant_wallet_required_fill_information');

    if (!otpCode) {
      setGeneralError(requiredMessage);
      return;
    }

    const reqParams = this.genBody();
    applyNewBankAccount(reqParams, otpCode).then((isSuccess) => {
      if (isSuccess) {
        this.handleClose();
      }
    });
  };

  genBody = () => {
    const {
      bank,
      bankAccountNumber,
      office,
      officeName,
      bankAccountName,
    } = this.state;

    return {
      bank_id: bank.value,
      account_no: bankAccountNumber,
      txn_office: office.value === -1 ? officeName : office.label,
      holder_name: bankAccountName,
    };
  };

  validateStep1 = () => {
    const { setGeneralError } = this.props;
    const requiredMessage = trans('merchant_wallet_required_fill_information');
    const schema = yup.object().shape({
      account_no: yup.string().required(requiredMessage),
      holder_name: yup.string().required(requiredMessage),
      bank_id: yup.number().required(requiredMessage),
      txn_office: yup.string().required(requiredMessage),
    });
    try {
      const reqParams = this.genBody();
      schema.validateSync(reqParams);
      return true;
    } catch (err) {
      setGeneralError(err.message);
      return false;
    }
  };

  renderStep1() {
    const {
      bankAccountNumber,
      bankAccountName,
      provinceOptions,
      officeOptions,
      bank,
      province,
      office,
      isSubmitStep1,
      officeName,
    } = this.state;
    const { bankOptions } = this.props;

    return (
      <div>
        <div className="note">{trans('np_withdraw_add_bank_account_desc')}</div>
        <InputWrapper label={trans('np_bank_account_number_hint')} required>
          <NowInput
            value={bankAccountNumber}
            onChange={this.handleInputChange('bankAccountNumber')}
            placeholder={trans('np_bank_account_number_hint')}
            required={isSubmitStep1}
          />
        </InputWrapper>
        <InputWrapper label={trans('np_bank_account_name_hint')} required>
          <NowInput
            value={bankAccountName}
            onChange={this.handleInputChange('bankAccountName')}
            placeholder={trans('np_bank_account_name_hint')}
            required={isSubmitStep1}
          />
        </InputWrapper>

        <InputWrapper label={trans('np_bank_name')} required>
          <NowSelect
            className="add-bank-account-select"
            value={bank}
            options={bankOptions}
            onChange={this.handleSelectBank}
            required={isSubmitStep1}
          />
        </InputWrapper>
        <InputWrapper label={trans('province')} required>
          <NowSelect
            className="add-bank-account-select"
            value={province}
            options={provinceOptions}
            onChange={this.handleSelectProvince}
            required={isSubmitStep1}
          />
        </InputWrapper>
        <InputWrapper label={trans('np_txn_office')} required>
          <NowSelect
            className="add-bank-account-select"
            value={office}
            options={officeOptions}
            onChange={this.handleSelectOffice}
            required={isSubmitStep1}
          />
          {office && office.value === -1 && (
            <NowInput
              value={officeName}
              onChange={this.handleInputChange('officeName')}
              placeholder={trans('np_bank_number_hint')}
              required={isSubmitStep1}
            />
          )}
        </InputWrapper>
        <div className="col-auto btn-wrap">
          <button className="btn btn-red modal-btn-confirm" onClick={this.handleStepChange(2)}>
            {trans('np_next')}
          </button>
          <button className="btn btn-white modal-btn-cancel" onClick={this.handleClose}>
            {trans('common_cancel')}
          </button>
        </div>
      </div>
    );
  }

  renderStep2() {
    const {
      bankAccountName,
      bankAccountNumber,
      bank,
      province,
      office,
      officeName,
    } = this.state;

    return (
      <div>
        <h3 className="title">{trans('confirm')}</h3>
        <div className="note">{trans('confirm')}</div>
        <div className="info-row">
          <div className="info-title">{trans('np_bank_account_number')}</div>
          <div className="info-value">{bankAccountNumber}</div>
        </div>
        <div className="info-row">
          <div className="info-title">{trans('np_bank_account_name')}</div>
          <div className="info-value">{bankAccountName}</div>
        </div>
        <div className="info-row">
          <div className="info-title">{trans('np_bank_name')}</div>
          <div className="info-value">{bank.label}</div>
        </div>
        <div className="info-row">
          <div className="info-title">{trans('province')}</div>
          <div className="info-value">{province.label}</div>
        </div>
        <div className="info-row">
          <div className="info-title">{trans('np_txn_office')}</div>
          <div className="info-value">
            {office.value === -1 ? officeName : office.label}
          </div>
        </div>
        <div className="btn-group-action  btn-wrap">
          <button className="btn btn-red modal-btn-confirm" onClick={this.handleStepChange(3)}>
            {trans('np_next')}
          </button>
          <button className="btn btn-white modal-btn-cancel" onClick={this.handleStepChange(1)}>
            {trans('back')}
          </button>
        </div>
      </div>
    );
  }

  renderStep3() {
    const { otpCode } = this.state;

    return (
      <div style={{ padding: 10 }}>
        <div className="enter-otp-desc">{trans('np_enter_otp_desc')}</div>
        <div className="input-otp-wrapper">
          <NowInput
            value={otpCode}
            onChange={this.handleInputChange('otpCode')}
            placeholder={trans('np_enter_verification_code')}
          />
          <button className="btn btn-white" onClick={this.handleRequestOTP}>
            {trans('np_resend_otp')}
          </button>
        </div>
        <div className="btn-wrap">
          <button className="btn btn-red modal-btn-confirm" onClick={this.handleSubmit}>
            {trans('np_next')}
          </button>
          <button className="btn btn-white modal-btn-cancel" onClick={this.handleStepChange(2)}>
            {trans('general_cancel')}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { step } = this.state;
    const { isOpen } = this.props;
    let body = null;

    if (step === 1) {
      body = this.renderStep1();
    } else if (step === 2) {
      body = this.renderStep2();
    } else if (step === 3) {
      body = this.renderStep3();
    }

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.handleClose}
        className="modal-add-bank-account"
      >
        <ModalHeader closeButton>{trans('np_add_bank_account')}</ModalHeader>
        <ModalBody>{body}</ModalBody>
      </Modal>
    );
  }
}

export default NowPortalAddBankAccountModal;



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalWithdraw/component/NowPortalAddBankAccountModal.jsx